import { render, staticRenderFns } from "./CryptoDepositsTable.vue?vue&type=template&id=7c6a64d2&scoped=true&"
import script from "./CryptoDepositsTable.vue?vue&type=script&lang=js&"
export * from "./CryptoDepositsTable.vue?vue&type=script&lang=js&"
import style0 from "./CryptoDepositsTable.vue?vue&type=style&index=0&id=7c6a64d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a64d2",
  null
  
)

export default component.exports